export const DATADOG_SAMPLE_RATE = 100;
export const DEFAULT_DEBOUNCE_VALUE = 300;
//# sourceMappingURL=constants.js.map